'use strict';

function addressBytes(value) {
  if (Array.isArray(value)) {
    var arrayBytes = value.map(function (part) { return Number(part); });
    return arrayBytes.every(function (part) {
      return Number.isInteger(part) && part >= 0 && part <= 255;
    }) ? arrayBytes : [];
  }
  var text = String(value == null ? '' : value).trim();
  if (!text) return [];
  var ipMatch = text.match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})(?::(\d{1,5}))$/);
  if (ipMatch) {
    var ip = ipMatch.slice(1, 5).map(Number);
    var port = Number(ipMatch[5]);
    if (ip.every(function (part) { return part >= 0 && part <= 255; }) && port >= 1 && port <= 65535) {
      return ip.concat([(port >> 8) & 0xff, port & 0xff]);
    }
  }
  var parts = text.split(/[.,]/).map(function (part) { return Number(String(part).trim()); });
  return parts.every(function (part) { return Number.isInteger(part) && part >= 0 && part <= 255; })
    ? parts
    : [];
}

function byteHex(value) {
  return Number(value).toString(16).padStart(2, '0').toUpperCase();
}

function addressHex(value) {
  return addressBytes(value).map(byteHex).join(' ');
}

function decodedAddress(value) {
  var bytes = addressBytes(value);
  if (bytes.length === 6) {
    return bytes.slice(0, 4).join('.') + ':' + ((bytes[4] << 8) | bytes[5]);
  }
  if (bytes.length === 1) return 'MAC ' + bytes[0];
  return '';
}

function routeLabel(device) {
  if (device == null || device.network == null || !addressBytes(device.address).length) return 'Direct';
  var hex = addressHex(device.address);
  var decoded = decodedAddress(device.address);
  return String(device.network) + ' / ' + hex + (decoded ? ' (' + decoded + ')' : '');
}

function isDirectRoute(device) {
  return !!device && device.network == null && !addressBytes(device.address).length;
}

function bacnetServer(device) {
  return ((device && device.breadcrumbs) || []).find(function (ancestor) {
    return ancestor && ancestor['@class'] === 'BacnetServer';
  }) || null;
}

function ridText(value) {
  if (value && value['@rid']) value = value['@rid'];
  var text = String(value == null ? '' : value).trim();
  return text && text !== '[object Object]' ? text : '';
}

function deviceRouteDetails(device, connection) {
  var server = bacnetServer(device);
  if (!server || server.transport !== 'bacnet-sc') return null;
  var direct = isDirectRoute(device);
  return {
    direct: direct,
    route: direct ? 'Direct BACnet/SC' : 'Routed through BACnet/SC',
    peerVmac: formatVmac(server.targetVmac),
    connection: connection && connection.name
      ? connection.name
      : ridText(server.scConnection) || '—',
    server: server,
  };
}

function formatVmac(value) {
  var normalized = String(value == null ? '' : value).trim().replace(/[:-]/g, '').toUpperCase();
  return /^[0-9A-F]{12}$/.test(normalized) ? normalized.match(/.{2}/g).join(':') : String(value || '');
}

function segmentationLabel(value) {
  var number = Number(value);
  if (number === 0) return 'Transmit and receive';
  if (number === 1) return 'Transmit';
  if (number === 2) return 'Receive';
  if (number === 3) return 'None';
  return '—';
}

function numericLabel(value) {
  return value === undefined || value === null || String(value).trim() === '' ? '—' : String(value);
}

function timestampLabel(value) {
  var number = Number(value);
  if (!Number.isFinite(number) || number <= 0) return '—';
  var date = new Date(number);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

module.exports = {
  addressBytes: addressBytes,
  addressHex: addressHex,
  decodedAddress: decodedAddress,
  routeLabel: routeLabel,
  isDirectRoute: isDirectRoute,
  bacnetServer: bacnetServer,
  deviceRouteDetails: deviceRouteDetails,
  formatVmac: formatVmac,
  segmentationLabel: segmentationLabel,
  numericLabel: numericLabel,
  timestampLabel: timestampLabel,
};
